import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { Support } from './components/Support';
import { Privacy } from './components/Privacy';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
